import React, { PureComponent } from 'react';
import Dropdown from '../standardAttributes/Dropdown';
import '../standardAttributes/Swatches.css';
export default class AboveOverheadLight extends PureComponent {
  renderSwatch() {
    const { configuration, attributeName, appApi } = this.props;
    if (!configuration[attributeName].value) return null;
    const {
      partNumber: value,
      thumbnailUrl: thumbnailurl,
    } = appApi.config.getProduct(configuration[attributeName].value);
    if (value.charAt(7) !== 'P') return null;
    return (
      <div className="swatchContainer vertical" id="parabolicFilter">
        <img className="swatchImage" src={thumbnailurl} alt={value} />
        <div className="parabolicText">Parabolic Filter Shown</div>
      </div>
    );
  }
  render() {
    return (
      <div>
        <Dropdown {...this.props} />
        {this.renderSwatch()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/AboveOverheadLight.js